
export const thingsToDoArr = [
    

  
      



]

// newVideos
export const newVideos = [

  {
      "title": "Sorprendente Vida Nocturna",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
      "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Amazing_Nightlife",
      "isVid": true,
      "forVidPage": true,
      "ctg": "telaviv",
      "vidId": "ogEN7aRT0SM",
      "id": "Amazing_Nightlife"
  },

  {
      "title": "Jerusalén",
      "sml_desc": "",
      "desc": "",
      "img": "Videos/heart-of-the-world.jpg",
      "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
      "side_img": "Videos/sidebar/heart-of-the-world.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Heart_Of_The_World",
      "vidId": "nLKWDp5uA-U",
      "ctg": "jerusalem",
      "forVidPage": true,
      "isVid": true,
      "id": "Heart_Of_The_World"
  },

  {
      "title" : "Aventuras al Aire Libre",
      "sml_desc" : "",
      "desc" : "",
      "side_img": "PostCarousel/TelAviv/tlv-on-wheels.jpg",
      "img_mob":"/PostCarousel/video_mob/tlv-on-wheels.jpg",
      "img": "PostCarousel/TelAviv/tlv-on-wheels.jpg",
      "read_more" : "READ MORE",
      "link": "/Posts/index.php?post=20",
      "css_class": "page-telaviv-adventures",
      "ctg": "telaviv",
      "vidId": "88OV6xU0vPI", 
      "isVid"  : true,
      "forVidPage": true,
      "id": "TelAviv_On_Wheels"
  },

  {
      "title": "El Mar Muerto",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/DeadSea/natural-spa.jpg",
       "img_mob":"/PostCarousel/video_mob/natural-spa.jpg",
      "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Dead_Sea2",
      "isVid": true,
      "forVidPage": true,
      "vidId": "3hxeenS25M0",
      "ctg": "deadsea",
      "id": "Dead_Sea2"
  },

  {
      "title": "JAFFA MÁGICA",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
      "img_mob":"/PostCarousel/video_mob/joys-of-jaffa.jpg",
      "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Joys_Of_Jaffa",
      "isVid": true,
      "forVidPage": true,
      "vidId":"uC5KX4MVpC0",
      "ctg": "telaviv",
      "id": "Joys_Of_Jaffa"
  },

  {
      "title": "TEL AVIV JUNTO AL MAR",
      "sml_desc": "",
      "desc": "",
      "img": "Videos/a.jpg",
      "img_mob":"/Videos/video_mob/a.jpg",
      "side_img": "Videos/sidebar/a.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?postType=video&post=3",
      "css_class": "unic_video-post-4",
      "vidId": "EJAqEcK4Te0",
      "ctg": "telaviv",
      "forVidPage": true,
      "isVid": true,
      "id": "TelAviv_By_The_Sea"
  },

  {
      "title": "Sarona Tel Aviv",
      "desc": "",
      "sml_desc": "",
      "img": "Videos/d.jpg",
      "img_mob":"/Videos/video_mob/d.jpg",
      "side_img": "Videos/sidebar/d.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
      "vidId": "VubRqT0Z9CM",
      "ctg": "telaviv",
      "forVidPage": true,
      "isVid": true,
      "id": "Sarona_TelAviv"
  },

  {
      "title": "2 Ciudades Increibles",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
      "side_img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=42",
      "isVid": true,
      "vidId": "NlOJ-i5hJdI",
      "forVidPage": true,
      "ctg": "telavivAndJerusalem",
      "id": "2_AWESOME_CITIES"
  },

  {
     "title": "LA CIUDAD VIEJA!",
      "sml_desc" : "",
       "desc" : "",
      "img": "/PostCarousel/Jerusalem/jerusalem-old-city2.jpg",
      "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city2.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Jerusalem_Old_City",
      "isVid" : true,
      "vidId": "rkjLPq-Zsp8",
      "forVidPage": true,
      "ctg": "jerusalem",
      "id": "Jerusalem_Old_City"
  },

   {
     "title": "EL MAR MUERTO",
      "sml_desc" : "",
      "desc" : "",
      "img": "/PostCarousel/DeadSea/natural-spa1.jpg",
      "side_img": "/PostCarousel/DeadSea/natural-spa1.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Natural_Spa",
      "isVid" : true,
      "vidId": "Y2hAOLNcPKU",
      "ctg": "deadsea",
      "forVidPage": true,
      "id": "Natural_Spa"
  },
  
   {
      "title": "Jerusalén te está Llamando",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/4.jpg",
      "side_img": "/PostCarousel/4.jpg",
      "read_more": "Weiterlesen",
      "link": "/Posts/index.php?post=4",
      "ctg": "jerusalem",
      "isVid" : true,
      "vidId": "1Yx2Uht4rms",
      "forVidPage": true,
      "id": "Jerusalem_Calling"
  },

  {
      "title": "Las sorpresas de Jerusalén",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/38.jpg",
      "side_img": "/PostCarousel/38.jpg",
      "read_more": "READ MORE",
      "link": this.url + "/Posts/index.php?post=Cool Jerusalem",
      "ctg": "jerusalem",
      "forVidPage": true,
      "isVid" : true,
      "vidId": "nLKWDp5uA-U",
      "id": "Cool_Jerusalem"
  },
  
 
   
  {
      "title": "¿buscas la noche más animada?",
      "sml_desc": "",
      "desc": "",
      "img": "Videos/crazy-night.jpg",
      "img_mob":"/Videos/video_mob/crazy-night.jpg",
      "side_img": "Videos/sidebar/crazy-night.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Amazing_Nightlife",
      "vidId": "ogEN7aRT0SM",
      "ctg": "telaviv",
      "isVid": true,
      "forVidPage": true,
      "id": "Amazing_Nightlife"
  },

  {
      "title": "Lo Más Destacado de Tel Aviv",
       "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/17.jpg",
      "side_img": "/PostCarousel/17.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=17",
      "ctg": "telaviv",
      "isVid" : true,
      "vidId": "eRNnLm6R0LI",
      "forVidPage": true,
      "id": "TelAviv_Highlights"
  },

 

  {
     "title": "AVENIDA MAMILLA",
      "sml_desc" : "",
      "desc" : "",
      "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
      "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Mamilla_Avenue",
      "isVid" : true,
      "vidId": "JxSjC2kZfvI",
      "forVidPage": true,
      "ctg": "jerusalem",
      "id": "Mamilla_Avenue"
  },

  {
      "title": "Nuevo y Antiguo Jerusalén",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
      "img_mob":"/PostCarousel/video_mob/jerusalem-old-city.jpg",
      "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Modern_And_Vibrant",
      "css_class": "old-new-jer",
      "isVid": true,
      "forVidPage": true,
      "vidId": "JxSjC2kZfvI",
      "ctg": "jerusalem",
      "id": "New_And_OLd_Jerusalem"
  },
  {
      "title": "Neve Tzedek",
      "sml_desc": "",
       "desc": "",
      "img": "Videos/j.jpg",
      "img_mob":"/Videos/video_mob/j.jpg",
      "side_img": "Videos/sidebar/j.jpg",
      "read_more": "READ MORE",
      "vidId": "eRNnLm6R0LI",
      "link": "/Posts/index.php?postType=video&post=7",
      "css_class": "unic_video-post-13",
      "ctg": "telaviv",
      "isVid": true,
      "vidId": "eRNnLm6R0LI",
      "forVidPage": true,
      "id": "Neve_Tzedek"
  },

 

  {
      "title": "Placer de Compras",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/5.jpg",
      "side_img": "/PostCarousel/5.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Shopping_Delights",
      "ctg": "jerusalem",
      "isVid" : true,
      "forVidPage": true,
      "vidId":"JxSjC2kZfvI",
      "id": "Shopping_Delights"
  },

  {
      "title": "Tel Aviv en bici",
      "sml_desc": "",
      "desc": "",
      "img": "PostCarousel/39.jpg",
      "side_img": "PostCarousel/39.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=38",
      "ctg": "telaviv",
      "isVid" : true,
      "forVidPage": true,
      "vidId":"Iyziun92P5A",
      "id": "Cycle_TelAviv"
  },

  {
      "title": "Jerusalén “Obligados”",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/18.jpg",
      "side_img": "/PostCarousel/18.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Jerusalem_Musts",
      "isVid" : true,
      "forVidPage": true,
      "vidId": "rkjLPq-Zsp8",
      "ctg": "jerusalem",
      "id": "Jerusalem_Musts"
  },
       
  {
      "title": "Moderna y Vibrante",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/19.jpg",
      "side_img": "/PostCarousel/19.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?postType=video&post=8",
      "css_class": "modern-vibrant-jer",
      "isVid" : true,
      "vidId": "1Yx2Uht4rms",
      "forVidPage": true,
      "ctg": "jerusalem",
      "id": "Modern_And_Vibrant"
  },
  

  //Hadar asked to hide the video in this post on 18.01.2021
  // {
  //    "title" : "Tiempo de cultura",
  //     "sml_desc" : "",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Non_Stop_Culture",
  //     "isVid" : true,
  //     "vidId":"JxSjC2kZfvI",
  //     "forVidPage": true,
  //     "ctg": "telaviv",
  //     "id": "Non_Stop_Culture"
  // },
  //End Hadar asked to hide the video in this post on 18.01.2021

  {
     "title": "Placeres Portuarios",
      "sml_desc" : "",
       "desc" : "",
      "img": "/PostCarousel/3.jpg",
      "img_mob":"/PostCarousel/video_mob/3.jpg",
      "side_img": "/PostCarousel/3.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Port_Pleasures",
      "isVid": true,
      "forVidPage": true,
      "vidId": "uC5KX4MVpC0",
      "ctg": "telaviv",
      "id": "Port_Pleasures"
  },
 
  

  {
      "title": "PLAYAS SENSACIONALES",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
      "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=14",
      "isVid" : true,
      "vidId": "EJAqEcK4Te0",
      "ctg": "telaviv",
      "forVidPage": true,
      "id":"Sensational_Beaches"
  },

  {
      "title": "Emoción Sin Fin",
      "sml_desc": "",
      "desc": "",
      "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
      "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=Nonstop_Excitement",
      "ctg": "telaviv",
      "isVid" : true,
      "vidId": "Iyziun92P5A",
      "forVidPage": true,
      "id": "Nonstop_Excitement"
  },
  

  {
    "title":"EILAT EL VERANO INTERMINABLE",
    "sml_desc":"",
    "desc":"",
    "img":"/PostCarousel/eilat-calling.jpg",
    "side_img":"/PostCarousel/eilat-calling.jpg",
    "read_more":"READ MORE",
    "link": "/Posts/index.php?post=Eilat_Calling", 
    "css_class":"unic-post-eilat-calling",
    "isVid" : true,
    "vidId": "ZdnNT-GDJv4",
    "forVidPage": true,
    "ctg"   : 'eilat-negev',
    "id"    : 'Eilat_Calling'
},

  {
      "title":"EILAT EL VERANO INTERMINABLE",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/eilat-calling.jpg",
      "side_img":"/PostCarousel/eilat-calling.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Eilat_Calling", 
      "css_class":"unic-post-eilat-calling",
      "isVid" : true,
      "vidId": "ZdnNT-GDJv4",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Eilat_Calling'
  },

  {
      "title":"EL ARRECIFE DE DELFINES DE EILAT",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/eilat-doolphin-reef.jpg",
      "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
      "css_class":"unic-post-eilat-doolphin-reef",
      "isVid" : true,
      "vidId": "3Cvz8GoxNzA",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Eilat_Doolphin_Reef'
  },

  {
      "title":"EL MAJESTUOSO DESIERTO DE ISRAEL",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/majestic-desert.jpg",
      "side_img":"/PostCarousel/majestic-desert.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Majestic_Desert", 
      "css_class":"unic-post-majestic-desert",
      "isVid" : true,
      "vidId": "yXzhH92kREg",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Majestic_Desert'
  },

  {
      "title":"UBICACIÓN Y ENFOQUE",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/location-and-approach.jpg",
      "side_img":"/PostCarousel/location-and-approach.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Location_And_Approach", 
      "css_class":"unic-post-location-and-approach",
      "isVid" : true,
      "vidId": "5AAqIhkq_tQ",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Location_And_Approach'
  },

  {
      "title":"EL NEGEV: AVENTURA EN EL DESIERTO",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/action-fun-in-the-desert.jpg",
      "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
      "css_class":"unic-post-action-fun-in-the-desert",
      "isVid" : true,
      "vidId": "yXzhH92kREg",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Action_Fun_In_The_Desert'
  },

  {
      "title":"LA RUTA DEL INCIENSO",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/the-incense-route.jpg",
      "side_img":"/PostCarousel/the-incense-route.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=The_Incense_Route", 
      "css_class":"unic-post-the-incense-route",
      "isVid" : true,
      "vidId": "5AAqIhkq_tQ",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'The_Incense_Route'
  },

  {
      "title":"EXPLORE MASADA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/epic-masada.jpg",
      "side_img":"/PostCarousel/epic-masada.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Epic_Masada", 
      "css_class":"unic-post-epic-masada",
      "isVid" : true,
      "vidId": "XxWa_MNm5x8",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Epic_Masada'
  },

  {
      "title":"PARQUE DE TIMNA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/timna-treasures.jpg",
      "side_img":"/PostCarousel/timna-treasures.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Timna_Treasures", 
      "css_class":"unic-post-timna-treasures",
      "isVid" : true,
      "vidId": "i_4QKtXIeto",
      "forVidPage": true,
      "ctg"   : 'eilat-negev',
      "id"    : 'Timna_Treasures'
  },

  {
      "title":"CIUDAD VIEJA DE ACRE",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/acre.jpg",
      "side_img":"/PostCarousel/acre.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Acre", 
      "css_class":"unic-post-acre",
      "isVid" : true,
      "vidId": "KlXXyToCmCM",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Acre'
  },

  {
      "title":"HAIFA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/haifa.jpg",
      "side_img":"/PostCarousel/haifa.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Haifa", 
      "css_class":"unic-post-haifa",
      "isVid" : true,
      "vidId": "3ahATaKkhBk",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Haifa'
  },

  {
      "title":"SAFED",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/safed.jpg",
      "side_img":"/PostCarousel/safed.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Safed", 
      "css_class":"unic-post-safed",
      "isVid" : true,
      "vidId": "i3_ihL51bHo",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Safed'
  },

  {
      "title":"La puerta de entrada al Norte de Israel",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/bahai-gardens.jpg",
      "side_img":"/PostCarousel/bahai-gardens.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=The_Bahai_Gardens", 
      "css_class":"unic-post-bahai-gardens",
      "isVid" : true,
      "vidId": "3ahATaKkhBk",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'The_Bahai_Gardens'
  },

  {
      "title":"EL MAR DE GALILEE (Kinneret)",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/sea-of-galilee.jpg",
      "side_img":"/PostCarousel/sea-of-galilee.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
      "css_class":"unic-post-sea-of-galilee",
      "isVid" : true,
      "vidId": "haG-t3wwuMc",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'The_Sea_Of_Galilee'
  },

  {
      "title":"ROSH PINA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/rosh-pina.jpg",
      "side_img":"/PostCarousel/rosh-pina.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Rosh_Pina", 
      "css_class":"unic-post-rosh-pina",
      "isVid" : true,
      "vidId": "_qKbHL5-qrQ",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Rosh_Pina'
  },

  {
      "title":"NAZARET",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/nazareth.jpg",
      "side_img":"/PostCarousel/nazareth.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Nazareth", 
      "css_class":"unic-post-nazareth",
      "isVid" : true,
      "vidId": "1M7N5BcmjFM",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Nazareth'
  },


  {
      "title":"ACCIÓN EN LA GALILEA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/galilee-action.jpg",
      "side_img":"/PostCarousel/galilee-action.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Galilee_Action", 
      "css_class":"unic-post-galilee-action",
      "isVid" : true,
      "forVidPage": true,
      "vidId": "5Ep3GgxELag",
      "ctg"   : 'north',
      "id"    : 'Galilee_Action'
  },
      
  {
      "title":"LAGO HULA",
      "sml_desc":"",
      "desc":"",
      "img":"/PostCarousel/birdtastic-hula-lake.jpg",
      "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
      "read_more":"READ MORE",
      "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
      "css_class":"unic-post-birdtastic-hula-lake",
      "isVid" : true,
      "vidId": "ImobrsxsKl8",
      "forVidPage": true,
      "ctg"   : 'north',
      "id"    : 'Birdtastic_Hula_Lake'
  },

  {
    "title":"NAZARET",
    "sml_desc":"",
    "desc":"",
    "img":"/PostCarousel/nazareth.jpg",
    "side_img":"/PostCarousel/nazareth.jpg",
    "read_more":"READ MORE",
    "link": "/Posts/index.php?post=Nazareth", 
    "css_class":"unic-post-nazareth",
    "isVid" : true,
    "vidId": "1M7N5BcmjFM",
    "forVidPage": true,
    "isDouble": true,
    "ctg"   : 'north',
    "id"    : 'Nazareth'
  },

  {
    "title":"La puerta de entrada al Norte de Israel",
    "sml_desc":"",
    "desc":"",
    "img":"/PostCarousel/bahai-gardens.jpg",
    "side_img":"/PostCarousel/bahai-gardens.jpg",
    "read_more":"READ MORE",
    "link": "/Posts/index.php?post=The_Bahai_Gardens", 
    "css_class":"unic-post-bahai-gardens",
    "isVid" : true,
    "vidId": "3ahATaKkhBk",
    "forVidPage": true,
    "isDouble": true,
    "ctg"   : 'north',
    "id"    : 'The_Bahai_Gardens'
  },


]
// newVideos

// start showsArr

// export const showsArr = [
      
     
//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"",
//         css_class: "unic-singer-Pride_Parade_2020",
//         // id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },
      
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         // id: "Nickcave_Badseeds",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         // id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         // id: "Celine_Dion",
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         // id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Hutzot Hayotzer Jerusalem",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         // id: "Hutzot_Hayotzer_Jerusalem_2020", 
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         // id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         // id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         // id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Jerusalem March",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         // id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },

//       // return here
      

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         "isDouble": true,
//         // id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         "isDouble": true,
//         // id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },

      
       
      

      

//       /*----------------OLD SINGERS------------------*/

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Read More"
//       },


//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Read More"
//       },
      
//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Read More"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Read More"
//       },

//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Read More"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Read More"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Read More"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Read More"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Read More"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Read More"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Read More"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Read More"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Read More"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Read More"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Read More"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Read More"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Read More"
//       },

//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "READ MORE"
//       },

//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "unic-singer-inter-arts",
//         id: "The_International_Arts", 
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "READ MORE"
//       },

      

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img: "Concerts/71.jpg",
//         side_img: "Concerts/72.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         book_now : "READ MORE"
//       },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-dgtl2019",
//         id: "DGTL_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "unic-singer-tlv-nightrun2019",
//         id: "Night_Run_TelAviv",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "unic-singer-71",
//         book_now : "READ MORE"
//       },
      
//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tel Aviv Marathon",
//         desc: "",
//         date: "28.02.20",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Purim 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },

//        {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.20",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         // id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },

//       // THre Events that Hadar asked to hide for the next year, the email from 19-05-2020
//        // {
//       //   title: "The Rubinstein Piano Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "White Night",
//       //   desc: "",
//       //   date: "06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "unic-singer-white-night-2020",
//       //   // id: "White_Night_2020",
//       //   book_now : "READ MORE"
//       // },
//       // END THre Events that Hadar asked to hide for the next year, the email from 19-05-2020

// ];

// End showsArr

 export const showsArr = [];


export const faqData  = [ 
   {  
      id : 1 ,
      q : "Preguntas frecuentes sobre Covid19",
      answer : `
      <ol start="1">
                             
                <li>
                  <strong>Soy un turista en Israel y creo que podría tener el COVID-19, ¿A dónde debo acudir?</strong><br/>
                  Si tienes 38ºC o más de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la línea directa de 101 de Servicios de Urgencia de MDA para indicaciones médicas.
                  <strong className="ac-pink">
                    No acudas a una clínica o sala de urgencias.
                  </strong>
                </li>
                <li>
                  <strong>¿Cuándo volverá a aceptar Israel a visitantes de fuera</strong><br/>
                  En este momento no hay fecha conocida en la que Israel volverá a permitir la entrada a los visitantes extranjeros.
                </li>
              </ol>
                               
                          
      `,
      isOpen : false
   },
   {  
      id : 2 ,
      q : "¿ESTÁN TEL AVIV Y JERUSALÉN MUY LEJOS?",
      answer : `
      <p>
        ¡Al contrario! Están más cerca de lo que crees, sólo son 4-5horas de vuelo y podrás disfrutar de las soleadas playas de Tel Aviv y los espectaculares lugares de Jerusalén. Y lo mejor de todo es que de Tel Aviv a Jerusalén solo hay una hora de coche.
        </p>
      `,
      isOpen : false
   },

   {  
      id : 3 ,
      q : "¿CÓMO MOVERSE POR TEL AVIV Y JERUSALÉN?",
      answer : `
      
      <p>
       Los métodos de transporte más fáciles y utilizados son los autobuses, taxis y el tren. Jerusalén también tiene un tren ligero muy cómodo que va a los lugares más concurridos de la ciudad.
        </p>
      <p>
      Información acerca de estaciones de tren, rutas y horarios en: <a target="_blank" href="//www.rail.co.il">www.rail.co.il</a>
      </p>
      <p>
      Información acerca de rutas y horarios de autobús en: <a target="_blank" href="//www.bus.gov.il">www.bus.gov.il</a>  
      </p>
      <p>
      Atención al cliente de transporte público:  <a href="tel:*8787">*8787</a>  
      </p>
      <p>
       App de transporte público local- ‘Moovit’
      </p>
      <h4>
      Taxis 
      </h4>
      <p>
        Los taxis para viajar por la ciudad y a otras ciudades se pueden coger en la calle o reservar por teléfono o con apps específicas como Gett(GetTaxi)
      </p>

      <h4>
     Taxis Sherut
      </h4>
      <p>
         Los Taxis “Sherut” son furgonetas de 10-12 asientos que suelen seguir las rutas de los autobuses más importantes, dentro y entre las ciudades más importantes. El precio de estos taxis sherut es fijo y es similar a las tarifas de los autobuses regulares.
      </p>

      <h4>
     Alquiler de coche
      </h4>
      <p>
       La mayoría de los servicios de alquiler de coches del centro de Tel Aviv se encuentran en la calle Hayarkon, cerca de la playa de Tel Aviv, y en las zonas de hoteles en otras ciudades importantes.
      </p>

      <h4>
      Tel-O-Fun 
      </h4>
      <p>
        Tel-O-Fun es un servicio de compartir alquiler de bicicletas, proporcionado por la ciudad de Tel Aviv y disponible para residentes y turistas. El service servicio de Tel-O-Fun tiene 2.000 bicicletas en 200 estaciones que te permiten alquilar una bici y circular por 130km de vías específicas para ciclistas. Puedes comprar una tarjeta de acceso diario o semanal con una tarjeta de crédito en cualquier terminal de estación de alquiler.
      </p>
      .
      `,
      isOpen : false,
   },
   

   {  
      id : 4 ,
      q : "¿Y EL DINERO?",
      answer : `
      <p>
       La divisa israelí es el Shekel. Se puede sacar dinero en los cajeros de los bancos por toda la ciudad. También están disponibles cajeros privados en kioscos locales, con una comisión de 5,90-7,90 NIS cada vez que retiras dinero. Los servicios La oficinas de cambio privadas están en oficinas privadas en áreas turísticas y no cobran comisión, suelen estar abiertas hasta tarde. Por supuesto, se aceptan las tarjetas de crédito en muchos sitios. Western Union funciona en la mayoría de las oficinas de correos y ofrecen servicios de transferencias.
      </p>
      `,
      isOpen : false,
   },
   

   {  
      id : 5 ,
      q : "MANTENER EL CONTACTO",
      answer : `

        <h4>
          Phone Services
        </h4>
        <p>
          Si lo necesitas, puedes comprar una tarjeta SIM local, de en una tienda de telefonía o un centro de información turística, y cupones para pagar cargarla según lo vayas utilizando necesitando, en muchas tiendas y cabinas de cambio.
        </p>

        <h4>
         Zona Wifi –Wifi Gratuito
        </h4>
        <p>
          Tel Aviv se enorgullece de ser una ciudad moderna y actualizada. Hay Wifi gratis en 80 ubicaciones por toda la ciudad (incluso en la playa, centros de ocio y la mayoría de las zonas turísticas)</p>
        <p>
         En Jerusalén, las zonas de WIFI gratuito están en las estaciones de tren, universidades, museos, centros turísticos, salas de convenciones, zonas turísticas, centros comerciales y también en el Centro de Información al Turista.

        </p>

      `,
      isOpen : false,
   },
   

   {  
      id : 6 ,
      q : "¿CÓMO ES EL TIEMPO?",
      answer : `
        <p>
        El tiempo en Tel Aviv es cálido y agradable la mayor parte del año. Los veranos son largos y perfectos para la playa y para ir de excursión, mientras que los inviernos son agradables sin demasiada lluvia. Temperatura media en invierno: 9-17 ºC. Temperatura media en verano: 24-30ºC.
        </p>
        <p>
          En Jerusalén los veranos son largos y soleados (mayo-septiembre) y los inviernos (noviembre-marzo) pueden llegar a ser muy fríos y lluviosos con alguna tormenta de nieve ocasional y las temperaturas bajan a – de 0ºC. Hay información actualizada en el Servicio Meteorológico Israelí: <a target="_blank" href="//www.ims.gov.il">www.ims.gov.il</a>

        </p>
      `,
      isOpen : false,
   },

   {  
      id : 7 ,
      q : "¿SON DISTINTOS LOS DÍAS LABORABLES?",
      answer : `
        
        <p>
        Sí, se trabaja de domingo a jueves y el fin de semana es de viernes a sábado. La mayoría de los negocios abren el viernes hasta primera hora de la tarde, antes del Shabbat judío, que comienza a la puesta de sol el viernes y dura hasta la puesta de sol del sábado. www.timeanddate.com/worldclock/Israel
        </p>
      `,
      isOpen : false,
   },
   
]

// newPosts
export const newPosts = [

    {
        "title": "Sorprendente Vida Nocturna",
        "sml_desc": "",
        // "sml_desc": "Sorprendente Vida Nocturna",
        "desc": "",
        // "desc": "¡Es una fiesta sin fin <br>en la ciudad sin descanso!",
        "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Amazing_Nightlife"
    },

    {
        "title": "Jerusalén",
        // "sml_desc": "El corazón del mundo",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/heart-of-the-world.jpg",
        "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
        "side_img": "Videos/sidebar/heart-of-the-world.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Heart_Of_The_World",
        "vidId": "nLKWDp5uA-U",
        "ctg": "jerusalem",
        "forVidPage": true,
        "isVid": true,
        "id": "Heart_Of_The_World"
    },

    

    {
      "title" : "Aventuras al Aire Libre",
      // "sml_desc" : "Outdoor Adventures",
      // "sml_desc" : "Tel Aviv sobre ruedas",
      "sml_desc" : "",
      // "desc" : "Ciudad repleta de acción – perfecta<br> para personas activas",
      "desc" : "",
      "side_img": "PostCarousel/TelAviv/tlv-on-wheels.jpg",
      "img_mob":"/PostCarousel/video_mob/tlv-on-wheels.jpg",
      "img": "PostCarousel/TelAviv/tlv-on-wheels.jpg",
      "read_more" : "READ MORE",
      "link": "/Posts/index.php?post=20",
      "css_class": "page-telaviv-adventures",
      "ctg": "telaviv",
      "vidId": "88OV6xU0vPI", 
      "isVid"  : true,
      "forVidPage": true,
      "id": "TelAviv_On_Wheels"
    },

    {
        "title": "El Mar Muerto",
        // "sml_desc": "Es hora de disfrutar en el<br> espledor de la naturaleza",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/natural-spa.jpg",
         "img_mob":"/PostCarousel/video_mob/natural-spa.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Dead_Sea2",
        "isVid": true,
        "forVidPage": true,
        "vidId": "3hxeenS25M0",
        "ctg": "deadsea",
        "id": "Dead_Sea2"
    },

    {
        "title": "JAFFA MÁGICA",
        "sml_desc": "",
        // "sml_desc" : "Una ciudad de encanto multicultural",
        "desc": "",
         // "desc" : "Experimente todas las riquezas que ofrece la hermosa y antigua Jaffa",
        "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
        "img_mob":"/PostCarousel/video_mob/joys-of-jaffa.jpg",
        "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Joys_Of_Jaffa",
        "isVid": true,
        "forVidPage": true,
        "vidId":"uC5KX4MVpC0",
        "ctg": "telaviv",
        "id": "Joys_Of_Jaffa"
    },

    {
        "title": "TEL AVIV JUNTO AL MAR",
        // "sml_desc": "Porque una playa en Tel Aviv es vida ",
        "sml_desc": "",
        // "desc": "Prepárese para la diversión bajo el sol",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob":"/Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "EJAqEcK4Te0",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": "TelAviv_By_The_Sea"
    },

    {
        "title": "Sarona Tel Aviv",
        "desc": "",
        // "desc": "Una gran selección de atracciones <br/> en una impresionante colonia Templaria renovada",
        // "sml_desc": "Un asombroso oasis urbano",
        "sml_desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
        "vidId": "VubRqT0Z9CM",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": "Sarona_TelAviv"
    },

    // {
    //    "title": "PLACERES PORTUARIOS",
    //     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    //     "sml_desc" : "",
    //     // "desc": "Tel Aviv’s fascinating cultural scene",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
    //     "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Port_Pleasures",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Port_Pleasures"
    // },

    

    {
        "title": "2 Ciudades Increibles",
        // "sml_desc": "Una mágica e inolvidable <br>escapada hacia el sol",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=42",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telavivAndJerusalem",
        "id": "2_AWESOME_CITIES"
    },


     // No Translation
    // {
    //    "title": "JERUSALEM",
    //     "sml_desc" : "",
    //      "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem"
    // },
    {
        "title": "Alegrías del Mar Muerto",
        // "sml_desc": "Para un buen momento flotante",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/deadsea1.jpg",
        "side_img": "/PostCarousel/DeadSea/deadsea1.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Next_Level_DS",
        "isVid": false,
        "ctg": "deadsea",
        "id": "Dead_Sea1"
    },

    // {
    //     "title": "Eurovision Tel Aviv",
    //     // "sml_desc": "Todo un clásico en la ciudad que nunca duerme",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/eurovision.jpg",
    //     "side_img": "/PostCarousel/eurovision.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=33",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Eurovision"
    // },

    {
        "title": "Información turística",
        // "sml_desc": "Todo lo que necesitas saber",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/touristinfo.jpg",
        "side_img": "/PostCarousel/touristinfo.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=41",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Tourist_Information"
    },

    // {
    //     "title": "The Dead Sea",
    //     // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/DeadSea/next-level.jpg",
    //     "side_img": "/PostCarousel/DeadSea/next-level.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Next_Level_DS",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Next_Level_DS"
    // },

    // No Translation
    // {
    //     "title": "Tel Aviv",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Tel_Aviv",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Tel_Aviv"
    // },
    {
       "title": "LA CIUDAD VIEJA!",
        "sml_desc" : "",
         // "sml_desc": "Sienta cómo la historia cobra vida",
         "desc" : "",
         // "desc": "Inspírese con los tesoros de fama mundial de la antigua ciudad de Jerusalén",
        "img": "/PostCarousel/Jerusalem/jerusalem-old-city2.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city2.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Old_City",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Old_City"
    },

     // No Translation
    // {
    //    "title": "NATURE'S GLORY",
    //     // "sml_desc": "THE DEAD SEA",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Natures_Glory",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Natures_Glory"
    // },
   
    {
        "title": "GUÍA",
        // "sml_desc": "Travel from Tel Aviv and Jerusalem",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/34.jpg",
        "side_img": "/PostCarousel/34.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=35",
        "ctg": "telaviv",
        "isVid": false,
        // "id": 35
        "id": "Go_To_Guide"
    }, 
   
   

    // No Translation
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
     {
       "title": "EL MAR MUERTO",
        "sml_desc" : "",
        // "sml_desc": "THE DEAD SEA",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-spa1.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-spa1.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Spa",
        "isVid": false,
        "ctg": "deadsea",
        "forVidPage": true,
        "id": "Natural_Spa"
    },
    




     // No Translation
    // {
    //     "title": "Upscale Jerusalem",
    //     // "sml_desc": "Modern luxuries for the pampered traveler",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/45.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/45.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=45",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 45
    // },
     {
        "title": "Jerusalén te está Llamando",
        // "sml_desc": "La ciudad más mágica y <br>radiante de la Tierra",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/4.jpg",
        "side_img": "/PostCarousel/4.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=4",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": "Jerusalem_Calling"
    },
    {
          "title": "Jerusalén",
          // "sml_desc": "El corazón del mundo",
          "sml_desc": "",
          // "desc": "",
          "desc": "",
          "img": "Videos/heart-of-the-world.jpg",
          "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
          "side_img": "Videos/sidebar/heart-of-the-world.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=Heart_Of_The_World",
          "vidId": "nLKWDp5uA-U",
          "ctg": "jerusalem",
          "forVidPage": true,
          "isVid": true,
          "isDouble": true,
          "id": "Heart_Of_The_World"
        },


    // No Translation
    // {
    //    "title": "NATURAL PHENOMENA",
    //     // "sml_desc": "THE DEAD SEA",
    //      "sml_desc": "",
    //     "desc" : "",
    //     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Natural_Phenomena",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Natural_Phenomena"
    // },
    {
        // "title": "A Foodie’s Paradise‘",
        "title" : "Tel Aviv – Simplemente delicioso",
        // "sml_desc": "Un completo paraíso gourmet",
        "sml_desc": "",
        "desc": "",
        // "desc": "Cientos de espectaculares restaurantes, increíbles delicias de mercado y fenomenal comida callejera ",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinarytelaviv",
        "vidId": "yFfkbHHWIc4",
        "isVid": true,
        "forVidPage": true,
        "id": "Simply_Delicious"
    },


    {
        "title": "Las sorpresas de Jerusalén",
        // "sml_desc": "Una ciudad más allá de las expectativas",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/38.jpg",
        "side_img": "/PostCarousel/38.jpg",
        "read_more": "READ MORE",
        "link": this.url + "/Posts/index.php?post=Cool Jerusalem",
        "ctg": "jerusalem",
        "forVidPage": true,
        "isVid": false,
        "id": "Cool_Jerusalem"
    },
    {
       "title": "EL MAR MUERTO",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/magical-deadsea1.jpg",
        "side_img": "/PostCarousel/DeadSea/magical-deadsea1.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Magical_Deadsea",
        "isVid": false,
        "ctg": "deadsea",
        "id": "Magical_Deadsea"
    },
    {
        "title": "Jerusalén “Obligados”",
        // "sml_desc": "5 mejores cosas para hacer y ver en la impresionante ciudad",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Musts",
        "isVid": false,
        "forVidPage": true,
        "vidId": "rkjLPq-Zsp8",
        "ctg": "jerusalem",
        "id": "Jerusalem_Musts"
    },
    
    {
        "title": "MERCADO DE MAHANE YEHUDA",
        // "sml_desc": "Una fiesta para los sentidos",
        "sml_desc": "",
        // "desc": "No querrá perderse las vistas, los sonidos, los olores y, <br/> por supuesto, los sabores de este mercado",
        "desc": "",
        "img": "Videos/market-madness.jpg",
        "img_mob":"/Videos/video_mob/market-madness.jpg",
        "side_img": "Videos/sidebar/market-madness.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Market_Madness",
        "vidId": "oy9ozIvV7Co",
        "ctg": "culinary",
        "isVid": true,
        "forVidPage": true,
        "id": "Market_Madness"
    },


     // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
    {
        "title": "¿buscas la noche más animada?",
        // "sml_desc": " Reserva tu viaje a Tel Aviv ahora",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "vidId": "ogEN7aRT0SM",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Amazing_Nightlife"
    },
    // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

    


    // No Translation
    // {
    //    "title": "MASADA",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/DeadSea/masada.jpg",
    //     "side_img": "/PostCarousel/DeadSea/masada.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Masada",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Masada"
    // },
    {
        "title": "Lo Más Destacado de Tel Aviv",
        // "sml_desc": "Las 5 mejores cosas para<br> ver y hacer en la ciudad",
         "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/17.jpg",
        "side_img": "/PostCarousel/17.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=17",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "TelAviv_Highlights"
    },

    // No Translation
    // {
    //     "title": "First Time in Jerusalem",
    //     // "sml_desc": "The must list for the first time visitor",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "First_Time_In_Jerusalem"
    // },

    // No Translation
    // {
    //     "title": "Boutique Hospitality",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    //     "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Boutique_Hospitality",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Boutique_Hospitality"
    // },
    {
        "title": "Qué debe probar en Jerusalén",
        // "sml_desc": "Must eat dishes to try when visiting the magical city",
        "desc": "",
        "sml_desc": "",
        "img": "/PostCarousel/37.jpg",
         "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinaryjerusalem",
        "vidId": "oy9ozIvV7Co",
        "isVid": true,
        "forVidPage": true,
        "id": "A_Taste_Of_Jerusalem"
    },
    {
        "title": "PAUSA PARA UN CAFÉ EN TEL AVIV",
        // "sml_desc": "Tel Aviv over a fresh coffee",
        "sml_desc": "",
        // "desc": "Coffee shop culture is fundamental",
        "desc":" ",
        "img": "Videos/coffee.jpg",
         "img_mob":"/Videos/video_mob/coffee.jpg",
        "side_img": "Videos/sidebar/coffee.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=16",
        "vidId": "s6kkkk8_Q2g",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Coffee_In_TelAviv"
    },
    {
       "title": "LOS SECRETOS DE JERUSALÉN",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
        "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Sectrets_Of_Jewish_Jerusalem"
    },

    // No Translation
    // {
    //     "title": "Non Stop Markets",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
    //     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Non_Stop_Markets",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Non_Stop_Markets"
    // },
    {
       "title": "AVENIDA MAMILLA",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },
    


    // No Translation
    // {
    //     "title": "TOWER OF DAVID MUSEUM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/7.jpg",
    //     "side_img": "thingsToDo/sidebar/7.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "Tower_Of_David_Museum",
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
    


    // No Translation
    // {
    //    "title": "JERUSALEM’S ART",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_Arts",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Arts"
    // },

    {
        "title": "Nuevo y Antiguo Jerusalén",
        // "sml_desc": "Tesoros antiguos y lujos modernos",
        "sml_desc": "",
        "desc": "",
        // "desc": "Una aventura inspiradora en Jerusalén,<br> una ciudad increíble",
        "img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
        "img_mob":"/PostCarousel/video_mob/jerusalem-old-city.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Modern_And_Vibrant",
        "css_class": "old-new-jer",
        "isVid": true,
        "forVidPage": true,
        "vidId": "JxSjC2kZfvI",
        "ctg": "jerusalem",
        "id": "New_And_OLd_Jerusalem"
    },
    {
        "title": "Neve Tzedek",
        "sml_desc": "",
        // "sml_desc" : "Chic and Unique  ",
        // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
         "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "READ MORE",
        "vidId": "eRNnLm6R0LI",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Neve_Tzedek"
    },

    {
        "title": "Hora de Shakshuka",
        // "sml_desc": "¡Aprende a hacer el mundialmente <br>famoso, Plato Shkshuka!",
        // "desc": "¡Aprende a hacer el mundialmente <br>famoso, Plato Shkshuka!",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/Culinary/shakshuka-time.jpg",
        "img_mob":"/PostCarousel/video_mob/shakshuka-time.jpg",
        "side_img": "PostCarousel/Culinary/shakshuka-time.jpg",
        "read_more": "READ MORE",
        "vidId": "n4kCnPXEX7g",
        "link": "/Posts/index.php?post=22",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Shakshuka_Time"
      },

        // Double post - The same as A_Taste_Of_Jerusalem
    // {
    //    "title": "Qué debe probar en Jerusalén",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Must_Eat_In_Jerusalem"
    // },
    {
        "title": "TEL AVIV EL MEJOR DESTINO VEGANO DEL MUNDO",
        // "sml_desc": "Voted # 1 Vegan destination in the world  ",
        // "desc": "Enjoy the huge choice of vegan",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/h.jpg",
        "img_mob":"/Videos/video_mob/h.jpg",
        "side_img": "Videos/sidebar/h.jpg",
        "vidId": "Gl-YB8qK5WI",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=6",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Vegan_Friendly_TelAviv"
    },
   
    
    {
            "title": "GASTRONOMÍA EN JERUSALÉN",
            "sml_desc": "",
            // "sml_desc": "Los 5 restaurantes más<br> singulares de Jerusalén",
            // "desc": "Jerusalén tiene un sabor ecléctico, desde <br>comida casera a especialidades gastronómicas",
            "desk": "",
            "img": "PostCarousel/Culinary/cuisine-jer.jpg",
            "img_mob":"/PostCarousel/video_mob/cuisine-jer.jpg",
            "side_img": "PostCarousel/Culinary/cuisine-jer.jpg",
            "read_more": "READ MORE",
            "vidId": "oy9ozIvV7Co",
            "link": "/Posts/index.php?post=13",
            "ctg": "culinaryjerusalem",
            "isVid": true,
            "forVidPage": true,
            "id": "Jerusalem_Cuisine"
        },
    {
        "title": "Cosas geniales que hacer en Tel Aviv",
        // "sml_desc": "Cosas geniales que hacer en Tel Aviv",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/40.jpg",
        "side_img": "/PostCarousel/40.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=TelAviv_Adventures",
        "ctg": "telaviv",
        "isVid": false,
        "id": "TelAviv_Adventures"
    },
    {
        "title": "Placer de Compras",
        // "sml_desc": "De la alta costura a los <br>recuerdos - Jerusalén lo tiene todo",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "vidId":"JxSjC2kZfvI",
        "id": "Shopping_Delights"
    },

    // No Translation
    // {
    //     "title": "UNFORGETTABLE YAD VASHEM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/10.jpg",
    //     "side_img": "thingsToDo/sidebar/10.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 31,
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
    


    // No Translation
    // {
    //    "title": "THE GATES OF JERUSALEM",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/gates.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/gates.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "The_Gates_Of_Jerusalem"
    // },
    {
        "title": "EXCURSIONES DE DÍA",
        "sml_desc": "",
        // "sml_desc" : "De puerto a puerto",
        "desc": "",
         // "desc" : "Fabulous and fascinating one day in Tel Aviv",
        "img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
        "side_img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Day_IsTrippin",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Day_IsTrippin"
    },


    // No Translation
    // {
    //     "title": "JERUSALEM MAIN SITES",
    //     // "sml_desc": "Travel back thousands of years",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=9",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 99
    // },

    // No Translation
    // {
    //     "title": "GOURMET TEL AVIV",
    //     // "sml_desc": "The perfect place\n to treat yourself",
    //     "sml_desc": "",
    //     // "desc": "Tel Aviv's huge variety of amazing",
    //     "desc": "",
    //     "img": "Videos/e.jpg",
    //     "img_mob":"/Videos/video_mob/e.jpg",
    //     "side_img": "Videos/sidebar/e.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?postType=video&post=33",
    //     "vidId": "jfyHxk8ZRrI",
    //     "ctg": "culinarytelaviv",
    //     "isVid": true,
    //     "id": "Gourmet_TelAviv"
    // },


    // No Translation
    // {
    //     "title": "WESTERN WALL WONDERS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/4.jpg",
    //     "side_img": "thingsToDo/sidebar/4.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Western_Wall_Wonders",
    //     "css_class": "unic_video-post-Western_Wall_Wonders",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "Western_Wall_Wonders",
    //     "ctg": "jerusalem",
    //     "showOnHome": false,

    // },
    {
        "title": "TEL AVIV Y JERUSALÉN",
        // "sml_desc": "diversión sin parar para toda la familia",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/33.jpg",
        "side_img": "/PostCarousel/33.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=25",
        "isVid": false,
        "ctg": "telavivAndJerusalem",
        "id": 41
    },


    // No Translation
    // {
    //     "title": "Travelling on a Budget",
    //     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/44.jpg",
    //     "side_img": "/PostCarousel/44.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=44",
    //     "isVid": false,
    //     "ctg": "telavivAndJerusalem",
    //     "id": 44
    // },
    {
       "title": "COMPRAS EN ISRAEL",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/unique.jpg",
        "side_img": "/PostCarousel/Jerusalem/unique.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Purchases_In_Israel",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Purchases_In_Israel"
    },


    // No Translation
    // {
    //    "title" : "Tel Aviv street food",
    //     // "sml_desc" : "Tel Aviv street food",
    //     "sml_desc" : "",
    //     // "desc" : "A true world-class foodie destination",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Tel_Aviv_Street_Food"
    // },
  
    {
        "title": "Tel Aviv en bici",
        // "desc": "Get on your bicycle -<br> explore the city in style",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "vidId":"Iyziun92P5A",
        "id": "Cycle_TelAviv"
    },
    

    // No Translation
    // {
    //     "title": "ULTIMATE BEACH FUN",
    //     "sml_desc": "",
    //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
    //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": true,
    //     "id":"Ultimate_Beach_Fun",
    //     "ctg": "telaviv",
    //     "showOnHome": false,

    // },
    // End No Translation
     


         
    {
        "title": "Moderna y Vibrante",
        // "sml_desc": "Mucho que ver en el bullicioso centro de la ciudad de Jerusalén",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/19.jpg",
        "side_img": "/PostCarousel/19.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=8",
        "css_class": "modern-vibrant-jer",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Modern_And_Vibrant"
    },

    // No Translation
    // {
    //     "title": "WHITE CITY SPLENDOR",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "thingsToDo/6.jpg",
    //     "side_img": "thingsToDo/sidebar/6.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 28,
    //     "showOnHome": false,
    //     "ctg": "telaviv"

    // },

    // No Translation
    // {
    //    "title": "Jerusalem after dark fun",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_After_Dark_Fun"
    // },
    

    // Hadar asked toi hide this post
    // {
    //    "title": "EL MEJOR HUMUS DE JERUSALÉN",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/15.jpg",
    //     "side_img": "/PostCarousel/15.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=15",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Humus_In_Jerusalem"
    // },
    {
        "title": "El destino de lujo definitivo",
        // "sml_desc": "Enjoy and Indulge",
        "sml_desc": "",
        // "desc": "Tel Aviv - The ultimate luxury destination",
        "desc": "",
        "img": "/PostCarousel/36.jpg",
        "side_img": "/PostCarousel/36.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=37",
        "ctg": "telaviv",
        "isVid": false,
        "id": "Enjoy_And_Indulge"
    },

    //Hadar asked to hide the video in this post on 18.01.2021
    {
       "title" : "Tiempo de cultura",
        // "sml_desc": "Una variedad de fascinantes<br> museos y galerías únicas",
        "sml_desc" : "",
        // "desc": "Una variedad de fascinantes <br>museos y galerías únicas",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Non_Stop_Culture",
        "isVid": false,
        "vidId":"JxSjC2kZfvI",
        "forVidPage": false,
        "ctg": "telaviv",
        "id": "Non_Stop_Culture"
    },
    //Hadar asked to hide the video in this post on 18.01.2021


    // No Translation
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "culinary"

    // },

    
    {
      "title": "PAUSA PARA UN CAFÉ EN TEL AVIV",
      "sml_desc": "",
      "desc":" ",
      "img": "Videos/coffee.jpg",
       "img_mob":"/Videos/video_mob/coffee.jpg",
      "side_img": "Videos/sidebar/coffee.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?postType=video&post=16",
      "vidId": "s6kkkk8_Q2g",
      "ctg": "culinarytelaviv",
      "isVid": true,
      "forVidPage": true,
      "id": "Coffee_In_TelAviv"
    },
  
    {
      "title": "LA OFERTA CULINARIA DE TEL AVIV",
      "sml_desc": "",
      "desc": "",
      "img": "Videos/culinary-offer.jpg",
      "img_mob":"/Videos/video_mob/culinary-offer.jpg",
      "side_img": "Videos/sidebar/culinary-offer.jpg",
      "vidId": "yFfkbHHWIc4",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=6",
      "ctg": "culinarytelaviv",
      "isVid": true,
      "vidId": "yFfkbHHWIc4",
      "forVidPage": true,
      "id": "TLV_Culinary_Offer"
    },
    {
       "title": "Placeres Portuarios",
        // "sml_desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
        "sml_desc" : "",
        // "desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
         "desc" : "",
        "img": "/PostCarousel/3.jpg",
        "img_mob":"/PostCarousel/video_mob/3.jpg",
        "side_img": "/PostCarousel/3.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Port_Pleasures",
        "isVid": true,
        "forVidPage": true,
        "vidId": "uC5KX4MVpC0",
        "ctg": "telaviv",
        "id": "Port_Pleasures"
    },
   
    {
        "title": "Jamie Oliver degusta el desayuno de Tel Aviv",
        // "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/jamie-oliver.jpg",
        "img_mob":"/Videos/video_mob/jamie-oliver.jpg",
        "side_img": "Videos/sidebar/jamie-oliver.jpg",
        "vidId": "gGe4W8WaIiQ",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jamie_Oliver",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Jamie_Oliver"
    },
    // No Translation
    // {
    //     "title": "Party Capital",
    //     // "sml_desc": "Epic Nights in the non stop city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/42.jpg",
    //     "side_img": "/PostCarousel/42.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=42",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Party_Capital"
    // },
    {
        "title": "PLAYAS SENSACIONALES",
        // "sml_desc": "Come chill by the sunny beaches",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=14",
        "isVid": false,
        "ctg": "telaviv",
        "forVidPage": true,
        //"id": 14
        "id":"Sensational_Beaches"
    },
    {
        "title": "Emoción Sin Fin",
        // "sml_desc": "unforgettable Tel Aviv ",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Nonstop_Excitement",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "Nonstop_Excitement"
    },

    {
      "title": "Placeres Portuarios",
       // "sml_desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
       "sml_desc" : "",
       // "desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
        "desc" : "",
       "img": "/PostCarousel/3.jpg",
       "img_mob":"/PostCarousel/video_mob/3.jpg",
       "side_img": "/PostCarousel/3.jpg",
       "read_more": "READ MORE",
       "link": "/Posts/index.php?post=Port_Pleasures",
       "isVid": true,
       "forVidPage": true,
       "isDouble": true,
       "vidId": "uC5KX4MVpC0",
       "ctg": "telaviv",
       "id": "Port_Pleasures"
    },

    {
      "title": "El destino de lujo definitivo",
      // "sml_desc": "Enjoy and Indulge",
      "sml_desc": "",
      // "desc": "Tel Aviv - The ultimate luxury destination",
      "desc": "",
      "img": "/PostCarousel/36.jpg",
      "side_img": "/PostCarousel/36.jpg",
      "read_more": "READ MORE",
      "link": "/Posts/index.php?post=37",
      "ctg": "telaviv",
      "isDouble": true,
      "isVid": false,
      "id": "Enjoy_And_Indulge"
  },
    // Eilat Posts

        // No Translation from EXEL SEO
        // {
        //  "title":"EILAT",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat1.jpg",
        //  "side_img":"/PostCarousel/eilat1.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=EILAT1", 
        //  "css_class":"unic-post-EILAT1",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'EILAT1'
        // },
        // {
        //  "title":"Welcome to Eilat",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "side_img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Welcome_To_Eilat", 
        //  "css_class":"unic-post-welcome-to-eilat",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Welcome_To_Eilat'
        // },
        {
          "title": "NEOT SEMADAR",
          "sml_desc": "",
          "desc": "",
          "img": "PostCarousel/Neot_Semadar.jpg",
          "side_img": "PostCarousel/Neot_Semadar.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=Neot_Semadar",
          "css_class": "unic-post-Neot-Semadar",
          'isVid': false,
          // vidId: "ZdnNT-GDJv4",
          // "isVid": false,
          "forVidPage": true,
          "ctg": "eilat-negev",
          "id": "Neot_Semadar",
        },
        {
         "title":"¿POR QUÉ EILAT ES EL MEJOR DESTINO DE VACACIONES?",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-ultimate-holiday.jpg",
         "side_img":"/PostCarousel/the-ultimate-holiday.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Ultimate_Holiday", 
         "css_class":"unic-post-the-ultimate-holiday",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Ultimate_Holiday'
        },
       
        {
         "title":"EILAT EL VERANO INTERMINABLE",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-calling.jpg",
         "side_img":"/PostCarousel/eilat-calling.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Calling", 
         "css_class":"unic-post-eilat-calling",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Calling'
        },
        {
         "title":"EL ARRECIFE DE DELFINES DE EILAT",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
        },

        // No Translation from EXEL SEO
        // {
        //  "title":"Action Packed Eilat",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/action-packed-eilat.jpg",
        //  "side_img":"/PostCarousel/action-packed-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Action_Packed_Eilat", 
        //  "css_class":"unic-post-action-packed-eilat",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Action_Packed_Eilat'
        // },
        // {
        //  "title":"EILAT ULTIMATE BEACHSIDE",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
        //  "css_class":"unic-post-eilat-ultimate-beachside",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Eilat_Ultimate_Beachside'
        // },

        // No Translation from EXEL SEO
        // {
        //  "title":"One Day in Eilat",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=One_Day_In_Eilat", 
        //  "css_class":"unic-post-one-day-in-eilat",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'One_Day_In_Eilat'
        // },
        {
         "title":"EL MAJESTUOSO DESIERTO DE ISRAEL",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/majestic-desert.jpg",
         "side_img":"/PostCarousel/majestic-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Majestic_Desert", 
         "css_class":"unic-post-majestic-desert",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Majestic_Desert'
        },

        // No Translation from EXEL SEO
        // {
        //  "title":"Negev",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev.jpg",
        //  "side_img":"/PostCarousel/negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev1", 
        //  "css_class":"unic-post-negev",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev1'
        // },
        {
         "title":"ARAVÁ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/ha-arava.jpg",
         "side_img":"/PostCarousel/ha-arava.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Ha_Arava", 
         "css_class":"unic-post-ha-arava",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Ha_Arava'
        },
        {
         "title":"UBICACIÓN Y ENFOQUE",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/location-and-approach.jpg",
         "side_img":"/PostCarousel/location-and-approach.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Location_And_Approach", 
         "css_class":"unic-post-location-and-approach",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Location_And_Approach'
        },

        // No Translation from EXEL SEO
        // {
        //  "title":"STAY IN THE NEGEV",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/stay-in-the-negev.jpg",
        //  "side_img":"/PostCarousel/stay-in-the-negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Stay_In_The_Negev", 
        //  "css_class":"unic-post-stay-in-the-negev",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Stay_In_The_Negev'
        // },

        // No Translation from EXEL SEO
        // {
        //  "title":"Pure Desert Magic",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/pure-desert-magic.jpg",
        //  "side_img":"/PostCarousel/pure-desert-magic.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Pure_Desert_Magic", 
        //  "css_class":"unic-post-pure-desert-magic",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Pure_Desert_Magic'
        // },
        {
         "title":"EL NEGEV: AVENTURA EN EL DESIERTO",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
        },
        {
         "title":"LA RUTA DEL INCIENSO",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Incense_Route'
        },

        // No Translation from EXEL SEO
        // {
        //  "title":"Mount Karkom",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/mount-karkom.jpg",
        //  "side_img":"/PostCarousel/mount-karkom.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Mount_Karkom", 
        //  "css_class":"unic-post-mount-karkom",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Mount_Karkom'
        // },

        // No Translation from EXEL SEO
        // {
        //  "title":"Machtesh Ramon",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/machtes-ramon.jpg",
        //  "side_img":"/PostCarousel/machtes-ramon.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Machtesh_Ramon", 
        //  "css_class":"unic-post-machtes-ramon",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Machtesh_Ramon'
        // },
        {
         "title":"EXPLORE MASADA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/epic-masada.jpg",
         "side_img":"/PostCarousel/epic-masada.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Epic_Masada", 
         "css_class":"unic-post-epic-masada",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Epic_Masada'
        },

        // No Translation from EXEL SEO
        // {
        //  "title":"The Bedouin Experience",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Bedouin_Experience", 
        //  "css_class":"unic-post-the-bedouin-experience",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Bedouin_Experience'
        // },

        // No Translation from EXEL SEO
        // {
        //  "title":"The Israel National Trail",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-israel-national-trail.jpg",
        //  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Israel_National_Trail", 
        //  "css_class":"unic-post-the-israel-national-trail",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Israel_National_Trail'
        // },
        {
         "title":"PARQUE DE TIMNA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/timna-treasures.jpg",
         "side_img":"/PostCarousel/timna-treasures.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Timna_Treasures", 
         "css_class":"unic-post-timna-treasures",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Timna_Treasures'
        },
        {
         "title":"DESIERTO DE NEGEV - NO SE LO PIERDA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/negev-desert-dont-miss.jpg",
         "side_img":"/PostCarousel/negev-desert-dont-miss.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Negev_Desert_Dont_Miss", 
         "css_class":"unic-post-negev-desert-dont-miss",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Negev_Desert_Dont_Miss'
        },

        {
          "title":"EL NEGEV: AVENTURA EN EL DESIERTO",
          "sml_desc":"",
          "desc":"",
          "img":"/PostCarousel/action-fun-in-the-desert.jpg",
          "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
          "read_more":"READ MORE",
          "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
          "css_class":"unic-post-action-fun-in-the-desert",
          "isVid" : true,
          "vidId": "yXzhH92kREg",
          "forVidPage": true,
          "isDouble": true,
          "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
      },
        // No Translation from EXEL SEO
        // {
        //  "title":"NEGEV CHARMS",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev-charms.jpg",
        //  "side_img":"/PostCarousel/negev-charms.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev_Charms", 
        //  "css_class":"unic-post-negev-charms",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev_Charms'
        // },
        // End Eilat Posts


        // North Posts
        // No Translation from EXEL SEO
        // {
        //  "title":"Galilee",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/galilee.jpg",
        //  "side_img":"/PostCarousel/galilee.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Galilee", 
        //  "css_class":"unic-post-galilee",
        //  "isVid" : true,
        //  "ctg"   : 'north',
        //   "id"    : 'Galilee'
        // },

        // No Translation from EXEL SEO
        // {
        //  "title":"Caesarea",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/caesarea.jpg",
        //  "side_img":"/PostCarousel/caesarea.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Caesarea", 
        //  "css_class":"unic-post-caesarea",
        //  "isVid" : true,
        //  "ctg"   : 'north',
        //   "id"    : 'Caesarea'
        // },
        {
         "title":"CIUDAD VIEJA DE ACRE",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Acre'
       },
        {
         "title":"HAIFA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/haifa.jpg",
         "side_img":"/PostCarousel/haifa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Haifa", 
         "css_class":"unic-post-haifa",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Haifa'
        },
        {
         "title":"SAFED",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Safed'
        },
        {
         "title":"La puerta de entrada al Norte de Israel",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bahai-gardens.jpg",
         "side_img":"/PostCarousel/bahai-gardens.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Bahai_Gardens", 
         "css_class":"unic-post-bahai-gardens",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Bahai_Gardens'
        },
        {
         "title":"EL MAR DE GALILEE (Kinneret)",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/sea-of-galilee.jpg",
         "side_img":"/PostCarousel/sea-of-galilee.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
         "css_class":"unic-post-sea-of-galilee",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Sea_Of_Galilee'
        },
        {
         "title":"ROSH PINA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/rosh-pina.jpg",
         "side_img":"/PostCarousel/rosh-pina.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Rosh_Pina", 
         "css_class":"unic-post-rosh-pina",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Rosh_Pina'
        },
        {
         "title":"NAZARET",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth.jpg",
         "side_img":"/PostCarousel/nazareth.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth", 
         "css_class":"unic-post-nazareth",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Nazareth'
        },
        {
         "title":"Salud a israel",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/cheers-to-israel.jpg",
         "side_img":"/PostCarousel/cheers-to-israel.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Cheers_To_Israel", 
         "css_class":"unic-post-cheers-to-israel",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'culinarynorth',
          "id"    : 'Cheers_To_Israel'
        },
       
        {
         "title":"UNAS VACACIONES CULINARIAS EN LA GALILEA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilean-treat.jpg",
         "side_img":"/PostCarousel/galilean-treat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=A_Galilean_Treat", 
         "css_class":"unic-post-galilean-treat",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'culinarynorth',
          "id"    : 'A_Galilean_Treat'
        },
        {
         "title":"ACCIÓN EN LA GALILEA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
        },
        {
         "title":"Bet She’an",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bet-shean.jpg",
         "side_img":"/PostCarousel/bet-shean.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Bet_Shean", 
         "css_class":"unic-post-bet-shean",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'Bet_Shean'
        },
        
        {
         "title":"Zichron Ya’akov",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/zichron-yaakov.jpg",
         "side_img":"/PostCarousel/zichron-yaakov.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Zichron_Yaakov", 
         "css_class":"unic-post-zichron-yaakov",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'Zichron_Yaakov'
        },
        // {
        //  "title":"Discover the Wine Routes",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/discover-the-wine-routes.jpg",
        //  "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Discover_The_Wine_Routes", 
        //  "css_class":"unic-post-discover-the-wine-routes",
        //  "isVid" : true,
        //  "ctg"   : 'north',
        //   "id"    : 'Discover_The_Wine_Routes'
        // },
        
        {
         "title":"LAGO HULA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
        },
        {
         "title":"THE INCOMPARABLE KIBBUTZ EXPERIENCE",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/kibbutz-experience.jpg",
         "side_img":"/PostCarousel/kibbutz-experience.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Kibbutz_Experience", 
         "css_class":"unic-post-kibbutz-experience",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'The_Kibbutz_Experience'
        },
        {
         "title":"NATIONAL PARKS",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/national-parks.jpg",
         "side_img":"/PostCarousel/national-parks.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=National_Parks", 
         "css_class":"unic-post-national-parks",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'National_Parks'
        },
        
        {
         "title":"Tiberias (Tverya)",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/tiberias.jpg",
         "side_img":"/PostCarousel/tiberias.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Tiberias", 
         "css_class":"unic-post-tiberias",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'Tiberias'
        },
        {
         "title":"DESCUBRA LOS TESOROS OCULTOS DE LA GALILEA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/discover-galilei.jpg",
         "side_img":"/PostCarousel/discover-galilei.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Discover_Galilei", 
         "css_class":"unic-post-discover-galilei",
         "isVid" : false,
         "ctg"   : 'north',
          "id"    : 'Discover_Galilei'
        },

        {
          "title":"EL MAR DE GALILEE (Kinneret)",
          "sml_desc":"",
          "desc":"",
          "img":"/PostCarousel/sea-of-galilee.jpg",
          "side_img":"/PostCarousel/sea-of-galilee.jpg",
          "read_more":"READ MORE",
          "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
          "css_class":"unic-post-sea-of-galilee",
          "isVid" : false,
          "isDouble": true,
          "forVidPage": true,
          "ctg"   : 'north',
          "id"    : 'The_Sea_Of_Galilee'
        },
       


]
// newPosts

export const TouristInfoPosts = [


        {
         "title":"INMIGRACIÓN Y ADUANAS",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/immigration-customs.jpg",
         "side_img":"/PostCarousel/immigration-customs.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-immigration-customs",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Immigration_Customs'
        },
        {
         "title":"QUÉ PONER EN LA MALETA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/what-to-pack.jpg",
         "side_img":"/PostCarousel/what-to-pack.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-what-to-pack",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'What_To_Pack'
        },
        {
         "title":"ELECTRICIDAD",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/electrical-appliances.jpg",
         "side_img":"/PostCarousel/electrical-appliances.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-electrical-appliances",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Electrical_Appliances'
        },
        {
         "title":"CLIMA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/weather.jpg",
         "side_img":"/PostCarousel/weather.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-weather",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Weather'
        },
        {
         "title":"TRANSPORTE",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/transportation.jpg",
         "side_img":"/PostCarousel/transportation.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-transportation",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Transportation'
        },
        {
         "title":"PREGUNTAS MÁS FRECUENTES",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/faq.jpg",
         "side_img":"/PostCarousel/faq.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-faq",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Frequently_Asked_Questions'
        },
       // No Translation
        // {
        //  "title":"Israeli Currency",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/israeli-currency.jpg",
        //  "side_img":"/PostCarousel/israeli-currency.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=20", 
        //  "css_class":"unic-post-israeli-currency",
        //  "isVid" : false,
        //  "ctg"   : 'TouristInfo',
        //   "id"    : 'Israeli_Currency'
        // },
        
        {
         "title":"PASAPORTES Y VISAS",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/Passports-visa.jpg",
         "side_img":"/PostCarousel/Passports-visa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-Passports-visa",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Passports_Visa'
        },
        {
          "title":"UN DESTINO PARA TODOS",
          "sml_desc":"",
          "desc":"",
          "img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
          "side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
          "read_more":"READ MORE",
          "link": "/Posts/index.php?post=20", 
          "css_class":"unic-post-Passports-visa",
          "isVid" : false,
          "ctg"   : 'TouristInfo',
           "id"    : 'Destination_For_All'
         },

]

export const Reminders = [

       // Tel Aviv
      {
        "quote": "One of the world's 25 best cities for foodies",
        "site": "Business Insider",
        "img": "/References/1.jpg",
        "ctg": "Tel Aviv",

       
      },

      // Jerusalem
      {
        "quote": "TripAdvisor Traveler's Choice Award 2015",
        "site": "TripAdvisor",
        "img": "/References/9.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's leading party cities",
        "site": "Telegraph",
        "img": "/References/2.jpg",
        "ctg": "Tel Aviv",
       
      },
      

      {
        "quote": "One of the cities with most beautiful people",
        "site": "Conde Nast",
        "img": "/References/3.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "One of the 20 must visit destinations in the world  TNS",
        "site": "The National Student",
        "img": "/References/10.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the best beach party spots on the planet",
        "site": "USA Today",
        "img": "/References/4.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top 10 beach cities",
        "site": "National Geographic",
        "img": "/References/5.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "3rd Of 6 Top world’s holiest sites",
        "site": "National Geographic",
        "img": "/References/11.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's top ten cities",
        "site": "Lonely Planet",
        "img": "/References/6.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top ten hedonistic city breaks ",
        "site": "Lonely Planet",
        "img": "/References/7.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "I just thought it was magical… It instantly turned into my favorite trip.",
        "site": "TripAdvisor",
        "img": "/References/12.jpg",
        "ctg": "Jerusalem",
        "job" : "CEO, Stephen Kaufer about Jerusalem" ,
        "cssClass" : "make-it-smller"
      },

      {
        "quote": "The World’s New Dining Hotspot",
        "site": "Bloomberg.com",
        "img": "/References/8.jpg",
        "ctg": "Tel Aviv",
       
      },

      

]







// WEBPACK FOOTER //
// ./src/Data/Data.js